// import React, { useRef } from 'react';

// const data2 = {
//   id: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//   fleetEquipmentsId: '35f8f28d-e276-4b34-6bc0-08dbf58cd32b',
//   driverId: 'b9edf0f7-5cee-4b86-00ff-08dbe40fca7c',
//   scanningCode: null,
//   scanningDate: '2025-07-28',
//   description: 'ملاحظات',
//   details: [
//     {
//       id: '7e63040b-33aa-42cd-fee6-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: 'a74b8f9a-0feb-4f02-1a91-08dbfcae4023',
//       value: false,
//       description: null,
//       elementName: 'Warning Sings',
//       elementName2: 'علامات الانذار',
//       elementDescription: 'No warning lights on the dashbord are on, especially the brake system warning light.',
//       elementDescription2: 'لا يوجد أي أضواء تحذيرية مضاءة على لوحة العدادات، وخاصة ضوء التحذير الخاص بنظام المكابح.  ',
//       elementSort: 2
//     },
//     {
//       id: '3852d17f-2ac5-40e0-fee7-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '029b3e0f-276a-4a14-1a92-08dbfcae4023',
//       value: false,
//       description: null,
//       elementName: 'Wippers',
//       elementName2: 'المساحات',
//       elementDescription:
//         'Front wind shield wippers and mist system are working in good conditions (try with water to verify).',
//       elementDescription2:
//         'مساحات الزجاج الأمامية ونظانم رش رذاذ الماء يعملون بشكل سليم (قم بالتشغيل عن طريق تفعيل نظام رش رذاذ الماء للتأكد).',
//       elementSort: 3
//     },
//     {
//       id: '6c7bb0a0-9778-4656-fee8-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '59c872ac-d7f3-4551-9d15-08dbfe223cee',
//       value: false,
//       description: null,
//       elementName: 'Mirrors',
//       elementName2: 'المرايات',
//       elementDescription:
//         'Rear view mirror  and two side mirrors are availble, not damaged and adjusted to suit driver.',
//       elementDescription2: 'المرايا الجانبية والمرآة الخلفية موجودة وسليمة من أي ضرر ومضبوطة بما يناسب وضعية السائق.',
//       elementSort: 4
//     },
//     {
//       id: '31ed9f68-307d-4a3f-fee9-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '32f9cc5a-5900-48a2-1db6-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Glass Cleanness',
//       elementName2: 'نظافة الزجاج',
//       elementDescription:
//         'Front wind shield, rear glass if available and side windows (specially front ones) are clean enough to allow good visibilty to the street and the mirrors.',
//       elementDescription2:
//         'الزجاج الأمامي والخلفي إذا وجد والنزافذ الجانبسية (خاصة الأمتمية منها) نظيفة بما يسمح برؤية جيدة للطريق والمرايا.',
//       elementSort: 5
//     },
//     {
//       id: 'cfed0c8c-39ff-4ae7-feea-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: 'b225ad54-0054-4e45-1db7-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Horn',
//       elementName2: 'الزامور',
//       elementDescription: 'Horn is working.',
//       elementDescription2: 'الزامور يعمل',
//       elementSort: 6
//     },
//     {
//       id: '6bcd0f61-8f3f-45bf-feeb-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '36c36712-fe7a-4ff6-1db8-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Emergency Kits',
//       elementName2: 'عدة الطوارئ',
//       elementDescription:
//         'Both first aid and accident reporting kits are available and no items are short or  missing.',
//       elementDescription2: 'صندوق الإسعاف الأولي وعدة الإبلاغ عن الحوادث موجودة وسليمة ولايوجد أي نقص بمحتوياتها.',
//       elementSort: 7
//     },
//     {
//       id: '2344f765-f9dc-46eb-feec-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '417e3e3a-6a14-4bd2-1db9-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Fire Extinguishers',
//       elementName2: 'طفايات الحريق',
//       elementDescription: 'fire extinguishers are available, pressureized and with valid maintenance date.',
//       elementDescription2: 'طفايات الحريق موجودة ومضغوطة وضمن تاريخ صيانة ساري.',
//       elementSort: 8
//     },
//     {
//       id: '77aa8e4a-2f0a-49ea-feed-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '84c8dbfd-6f14-4c68-1dba-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Headand  Tail Lights',
//       elementName2: 'الأنوار الأمامية والخلفية',
//       elementDescription: 'All head and tail lights must be working, especially braking lights.',
//       elementDescription2: 'جميع الأنوار الأمامية والخلفية تعمل، وخاصة أضوية الفرملة.',
//       elementSort: 5
//     },
//     {
//       id: 'c5d6f3d0-3a7d-47e1-feee-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '0ce17011-bd38-43ec-1dbb-08dbfebffefc',
//       value: true,
//       description: null,
//       elementName: 'Turning Signal Lights',
//       elementName2: 'إشارات الإنعطاف',
//       elementDescription: 'All turning signal lights and flasher system must be working.',
//       elementDescription2: 'أضوية إشارات الإنعطاف ونظام التحذير الرباعي تعمل. ',
//       elementSort: 10
//     },
//     {
//       id: '4939be94-aa78-458d-feef-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '4c27c832-e0ed-430a-1dbc-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Tires',
//       elementName2: 'الإطارات',
//       elementDescription:
//         'No damage signs (cuts, swallons …etc.) other than normal wear and tear within acceptable limits and not over or under inflated.',
//       elementDescription2:
//         'لايوجد علامات تلف على الإطارات (قطع، سلخ، انتفاخ...إلخ) بخلاف التآكل الطبيعي وضمن الحدود المعقولة. وعي ليست بحاجة للنفخ (التعبئة بالهواء) أو منفوخة زيادة عن اللزوم.',
//       elementSort: 11
//     },
//     {
//       id: 'a1984ce0-4780-4672-fef0-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '942c67b7-0672-4aa3-1dbd-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Fluids Levels',
//       elementName2: 'مستوى السوائل',
//       elementDescription:
//         'Check the level of the following fluids at a minimum: engine oil, coolant, wippers fluid, brake oil and power steering oil.',
//       elementDescription2:
//         'تفقد وتأكد من مستوى السوائل التالية كحد أدنى: زيت المجرك، سائل تبريد المحرك، سائل مساحات الزجاج، زيت المكابح وزيت نظام مساعد المقود (البور ستيرنج).',
//       elementSort: 12
//     },
//     {
//       id: '0b078020-511d-44f8-fef1-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: 'b5d615ce-1fc8-4a31-1dbe-08dbfebffefc',
//       value: true,
//       description: null,
//       elementName: 'No Fluid Leaks',
//       elementName2: 'لا يوجد تسريب',
//       elementDescription:
//         'check and confirm that there is no sign of fluid leaks under the vehicles even if all fluid levels were ok.',
//       elementDescription2:
//         'تأكد من عدم وجود تهريب سوائل من المركبة سواء من نظام تبريد امحرك، أو من الفرامل أو أي تهريب يرجى حتى لو كانت جميع مستويات السوائل في المركبة ضمن المستوى السليم.',
//       elementSort: 13
//     },
//     {
//       id: 'b504874b-a9eb-4919-fef2-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '27073dd0-1d2a-4167-1dbf-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Hotline No.',
//       elementName2: 'رقم الشكاوى نظيف وواضح',
//       elementDescription: 'Hotline number must be available, clean and clear to be read.',
//       elementDescription2: 'رقم الهاتف المخصص للشكاوى، موجود، نظيف وواضح للقراءة.',
//       elementSort: 14
//     },
//     {
//       id: 'dd434abd-15a6-4324-fef3-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '1dbdd849-62ae-41b8-1dc0-08dbfebffefc',
//       value: false,
//       description: null,
//       elementName: 'Spare tire and changing kit ',
//       elementName2: 'عجل الاحتياط وعدة الإستبدال',
//       elementDescription:
//         'Spare tire must be available and inflated. Changing kit including at a minimum jack and wrench must be available.',
//       elementDescription2:
//         'العجل الآحتيطي موجود و مملوء بالهواء. وعدة الاستبدال والتي يجب أن تحتوي كحد أدنى على مفتاح الريط وجهاز الرفع المناسبين يجب أن تكون موجودة.',
//       elementSort: 15
//     },
//     {
//       id: 'b656bbdc-afd3-4b0c-fef4-08ddcc30b972',
//       scanningMasterId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       scanningElementId: '6493111f-aad2-4fe3-1dc1-08dbfebffefc',
//       value: true,
//       description: null,
//       elementName: 'No upnormal sounds',
//       elementName2: 'لا يوجد أصوات غير طبيعية',
//       elementDescription:
//         'Any upnormal sounds, specially from engine, brakes, suspension system or a sound of lose parts. This will mostly depend on you experience of last time you drove the vehicle.',
//       elementDescription2:
//         'لا يوجد أي أصوات غير طبيعية، خاصة من المحرك أو المكابح أو نظام التعليق (الأذرعة والمساعدات ...إلخ) أو أصوات من قطع وأجزاء غير مثبتة بشكل صحيح ومحكم. لربما يعتمد ذلك على ملاحظاتك أثناء قيادتك للمركبة آخر مرة.',
//       elementSort: 16
//     }
//   ],
//   markers: [
//     {
//       id: '44d7b660-9a3e-42be-f516-08ddd2a9d03a',
//       scanningMasterId: '431c336d-07e0-4d2b-912b-28d7d0e7640d',
//       xPosition: '442.984375',
//       yPosition: '47.5',
//       shape: 'ring',
//       color: 'red',
//       comment: 'Scratch',
//       size: '15'
//     },
//     {
//       id: 'aa8c7c09-3627-4817-f517-08ddd2a9d03a',
//       scanningMasterId: '431c336d-07e0-4d2b-912b-28d7d0e7640d',
//       xPosition: '210.984375',
//       yPosition: '35.5',
//       shape: 'ring',
//       color: 'red',
//       comment: 'Crack',
//       size: '15'
//     },
//     {
//       id: '162cbffd-6007-4e5b-f519-08ddd2a9d03a',
//       scanningMasterId: '431c336d-07e0-4d2b-912b-28d7d0e7640d',
//       xPosition: '341.984375',
//       yPosition: '250.5',
//       shape: 'ring',
//       color: 'red',
//       comment: 'comment 5',
//       size: '15'
//     },
//     {
//       id: 'affc921c-3dcf-45f7-f518-08ddd2a9d03a',
//       scanningMasterId: '431c336d-07e0-4d2b-912b-28d7d0e7640d',
//       xPosition: '530.984375',
//       yPosition: '287.5',
//       shape: 'ring',
//       color: 'red',
//       comment: 'In the Name Of Allah In the Name Of Allah ',
//       size: '15'
//     },
//     {
//       id: '162cbffd-6007-4e5b-f519-08ddd2a9d03a',
//       scanningMasterId: '431c336d-07e0-4d2b-912b-28d7d0e7640d',
//       xPosition: '341.984375',
//       yPosition: '308.5',
//       shape: 'ring',
//       color: 'red',
//       comment: 'Rust',
//       size: '15'
//     }
//   ],
//   kuroki: {
//     id: '66a3df74-dbfa-486b-a859-a86358ea566a',
//     referenceId: '32c5c6f8-f2f5-4b80-6e08-08ddc92bbe0d',
//     referenceType: 'Equipment_Model_Kuroki',
//     fileName: 'سياف_20250722_072626.jpg',
//     // filePath:
//     //   'https://neatixapi.aljown.com//TableAttachements/NTX/Fleet Equipment Models/ReferenceId_32c5c6f8-f2f5-4b80-6e08-08ddc92bbe0d/Type_Equipment_Model_Kuroki/سياف_20250722_072626.jpg',
//     filePath: '/assets/DamagedCarImage.png',
//     description: null,
//     size: 297451,
//     extensionFile: '.jpg',
//     creationDate: '2025-07-22T17:26:26.723'
//   },
//   attachment: [
//     {
//       id: '5f1a753b-3229-4add-8095-cc89c93860e1',
//       referenceId: '1011eaaf-13b2-41d9-bf81-1340c1cccfd7',
//       referenceType: 'Equipment_Scanning',
//       fileName: 'Pickup_Truck_Blueprint_20250726_043208.jpg',
//       filePath:
//         'https://neatixapi.aljown.com//TableAttachements/NTX/PERIODICALLY SCANNING MASTER/ReferenceId_1011eaaf-13b2-41d9-bf81-1340c1cccfd7/Type_Equipment_Scanning/Pickup_Truck_Blueprint_20250726_043208.jpg',
//       description: null,
//       size: 84351,
//       extensionFile: '.jpg',
//       creationDate: '2025-07-26T14:32:08.61'
//     }
//   ]
// };

// const inspectionData = [
//   { id: 1, name: 'Head Light RH', value: true },
//   { id: 2, name: 'Windshield Glass', value: true },
//   { id: 3, name: 'Front Door / Glass LH', value: true },
//   { id: 4, name: 'Spare Wheel', value: true },
//   { id: 5, name: 'Tool Kit', value: true },
//   { id: 6, name: 'Rear Light RH', value: true },
//   { id: 7, name: 'Lighter', value: true },
//   { id: 8, name: 'Leasing Co Approval', value: false },
//   { id: 9, name: 'Head Light LH', value: true },
//   { id: 10, name: 'Wipers', value: true },
//   { id: 11, name: 'Side Mirror LH', value: true },
//   { id: 12, name: 'Jack', value: true },
//   { id: 13, name: 'Rear Glass', value: true },
//   { id: 14, name: 'Rear Door / Glass RH', value: true },
//   { id: 15, name: 'Radio / Cassette', value: true },
//   { id: 16, name: 'Vehicle Key', value: true },
//   { id: 17, name: 'Signal Lamp RH', value: true },
//   { id: 18, name: 'Number Plate Front', value: true },
//   { id: 19, name: 'Rear Door / Glass LH', value: true },
//   { id: 20, name: 'Wheel Spanner', value: true },
//   { id: 21, name: 'Fuel Tank cap', value: true },
//   { id: 22, name: 'Front Door / Glass RH', value: false },
//   { id: 23, name: 'Estamara', value: true },
//   { id: 24, name: 'Signal Lamp LH', value: true },
//   { id: 25, name: 'Front Bumper / Grille', value: true },
//   { id: 26, name: 'Boot Lid / Number Plate', value: true },
//   { id: 27, name: 'Fire Extinguisher', value: true },
//   { id: 28, name: 'Rear Light LH', value: true },
//   { id: 29, name: 'Side Mirror RH', value: true },
//   { id: 30, name: 'Insurance', value: true },
//   { id: 31, name: 'Rear view Mirror RH/LH', value: true },
//   { id: 32, name: 'Back Door Pad Lock', value: false },
//   { id: 33, name: 'Chiller unit Control', value: true },
//   { id: 34, name: 'MOT', value: true },
//   { id: 35, name: 'Body Sticker RH', value: true },
//   { id: 36, name: 'Body Sticker LH', value: true },
//   { id: 37, name: 'Printer Bracket', value: true },
//   { id: 38, name: 'Logo Approval', value: true },
//   { id: 39, name: 'Coolent bottle Cap', value: true },
//   { id: 40, name: 'Battery Cover / Lock', value: true },
//   { id: 41, name: 'Safety Kit', value: true },
//   { id: 42, name: 'Stand by unit Cable', value: true },
//   { id: 43, name: 'Rear Doors & Lock', value: true },
//   { id: 44, name: 'Chiller unit', value: true },
//   { id: 45, name: 'Jack & two bars', value: true },
//   { id: 46, name: 'Fuel card NO', value: true },
//   { id: 47, name: 'Jack & two bars', value: true },
//   { id: 48, name: 'Fuel card NO', value: true },
//   { id: 49, name: 'Jack & two bars', value: true },
//   { id: 50, name: 'Fuel card NO', value: true }
// ];

import { FaTools } from 'react-icons/fa';
import { useEffect, useRef, useState } from 'react';
import './printCss.css';
import { useReactToPrint } from 'react-to-print';
import { getScanningByAssignationIdIdAndScanningTypeForPrint } from '@store/FLEET/FleetScan/fleetScanSlice';
import Kuroki from '../FleetScan/Kuroki2';
import { useAppDispatch } from '@store/hooks';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';

const Print = () => {
  const { i18n } = useTranslation();
  const { assignationId, scanningType } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const [data, setData] = useState<any>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // ⏳ بداية التحميل
      setError(null); // 🧹 مسح أي خطأ سابق

      try {
        const res = await dispatch(
          getScanningByAssignationIdIdAndScanningTypeForPrint({
            assignationId,
            scanningType
          })
        ).unwrap();

        if (res.succeeded) {
          setData(res.data);
        } else {
          setData(null);
          setError('فشل في جلب البيانات');
        }
      } catch (err) {
        setData(null);
        setError('حدث خطأ أثناء جلب البيانات');
        console.error(err);
      } finally {
        setLoading(false); // ✅ انتهاء التحميل سواء بنجاح أو خطأ
      }
    };

    if (assignationId && scanningType) {
      fetchData();
    }
  }, [assignationId, scanningType, dispatch]);

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef
  });

  const markers = data?.markers.map((m: any) => ({
    id: m.id,
    x: Number(m.xPosition),
    y: Number(m.yPosition),
    shape: m.shape,
    color: m.color,
    comment: m.comment || '',
    size: Number(m.size)
  }));

  const formik = {
    values: {
      markers: markers
    }
  };

  // عدد الأعمدة المطلوبة
  const columns = 4;
  // حساب عدد الصفوف المطلوبة
  const rows = Math.ceil(data?.details?.length / columns);
  // إنشاء الصفوف للجدول
  const renderTableRows = () => {
    const tableRows = [];

    for (let i = 0; i < rows; i++) {
      const rowCells = [];

      for (let j = 0; j < columns; j++) {
        const index = i + j * rows;

        if (index < data?.details.length) {
          const part = data?.details[index];
          rowCells.push(
            <td className='p-1 fs-10px fw-bold' key={`id-${index}`}>
              {/* {part.id} */}
              {index + 1}
            </td>
          );
          rowCells.push(
            <td className='d-flex justify-content-between p-1 fs-10px fw-bold' key={`name-${index}`}>
              {part.elementName}
              <input className='form-check-input' type='checkbox' checked={part.value} disabled />
            </td>
          );
        } else {
          // خلايا فارغة إذا لم تكن هناك بيانات كافية
          rowCells.push(<td key={`empty-${i}-${j}`}></td>);
          rowCells.push(<td key={`empty-${i}-${j}-2`}></td>);
        }
      }

      tableRows.push(<tr key={`row-${i}`}>{rowCells}</tr>);
    }

    return tableRows;
  };

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className='text-center mt-2'>
          <button onClick={reactToPrintFn} className='btn  btn-lg btn-outline-primary w-50'>
            print 
          </button>
        </div>
        <div className='a4-page' ref={contentRef}>
          <div className='p-2 border'>
            <div className='d-flex align-items-center mb-2 border-bottom bg-theme bg-opacity-10 p-1'>
              {/* الأيقونة */}
              <div className='me-3 text-primary'>
                <FaTools size={40} />
              </div>

              {/* اسم الشركة وبياناتها */}
              <div className='text-center flex-grow-1'>
                <h5 className='mb-0 fw-bold' style={{ fontSize: '16px' }}>
                  شركة مصدر الحياة للصناعات الغذائية
                </h5>

                {/* <p className='mb-0 fs-10px text-muted'>
                  العنوان: شارع الملك فهد، الرياض، المملكة العربية السعودية | تلفون: 0123456789 | البريد:
                  info@smartinspect.com
                </p> */}
              </div>
            </div>
            <h6 className='text-center mx-0   '>VEHICLE HAND OVER / TAKE OVER CHECK LIST</h6>

            <div className='row mt-1'>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold d-flex justify-content-start align-items-center '>
                    {'Make :'}
                  </span>
                  <input
                    className='form-control form-control-sm fs-12px'
                    type='text'
                    defaultValue={i18n.language === 'en' ? data?.modelName : data?.modelName2}
                  />
                </div>
              </div>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold    d-flex justify-content-start align-items-center '>
                    {'Plate No. :'}
                  </span>
                  <input
                    className='form-control form-control-sm fs-12px fs-12px'
                    type='text'
                    defaultValue={data?.plateNumber}
                  />
                </div>
              </div>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold   d-flex justify-content-start align-items-center '>
                    {'Date :'}
                  </span>
                  <input
                    className='form-control form-control-sm fs-12px'
                    type='text'
                    defaultValue={data?.scanningDate}
                  />
                </div>
              </div>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold   d-flex justify-content-start align-items-center '>
                    {'Model :'}
                  </span>
                  <input
                    className='form-control form-control-sm fs-12px'
                    type='text'
                    defaultValue={i18n.language === 'en' ? data?.modelName : data?.modelName2}
                  />
                </div>
              </div>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold   d-flex justify-content-start align-items-center '>
                    {'KM'}
                  </span>
                  <input className='form-control form-control-sm fs-12px' type='text' defaultValue={data?.odometer} />
                </div>
              </div>
              <div className='col-4 mb-1'>
                <div className='input-group'>
                  <span className='input-group-text fs-12px fw-bold  d-flex justify-content-start align-items-center '>
                    {'Supervisor :'}
                  </span>
                  <input
                    className='form-control form-control-sm fs-12px'
                    type='text'
                    defaultValue={i18n.language === 'en' ? data?.superVisorDriverName : data?.superVisorDriverName}
                  />
                </div>
              </div>
            </div>

            <hr />

            <table className='table table-bordered'>
              <tbody>{renderTableRows()}</tbody>
            </table>

            <div className='row mt-3'>
              <div className='col-xl-12 mb-2'>
                <div className='input-group'>
                  <span className='input-group-text  d-flex justify-content-center'>{'Remarks'}</span>
                  <textarea className='form-control' rows={2} defaultValue={data?.description}></textarea>
                </div>
              </div>
            </div>
            <hr className='m-0  ' />

            <div className='row mt-3'>
              <div className='col-12 text-center  '>
                <Kuroki formik={formik} KurokiImage={data?.kuroki?.filePath ?? ''} />
              </div>
            </div>

            <hr />

            <div className='row g-1'>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Checked By'}</span>
                  <input type='text' className='form-control border-0 border-bottom ' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'ID No'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Signature'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
            </div>
            <div className='row g-1'>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Received From'}</span>
                  <input type='text' className='form-control border-0 border-bottom ' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'ID No'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Signature'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
            </div>
            <div className='row g-1'>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Handed Over To'}</span>
                  <input type='text' className='form-control border-0 border-bottom ' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'ID No'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
              <div className='col-4 mb-2'>
                <div className='input-group'>
                  <span className='d-flex align-items-center fs-10px fw-bold'>{'Signature'}</span>
                  <input type='text' className='form-control  border-0 border-bottom' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default Print;
